import { copyArr } from "core/iterable_utils";

export const updateSourceData = ({ state, payload }) => {
	const changeInfo = payload?.change_info;

	const sourceData = copyArr(payload.source_data).map((row) => {
		if (["ADD", "EDIT"].includes(changeInfo?.action) && changeInfo?.object_type === "source_data") {
			if (changeInfo.object_id === row?.id) row.selected = true;
		}
		return row;
	});
	return sourceData;
};
